import { find, isEqual } from "lodash";
import { h } from "preact";
import {
  IWidgetConfigurationProps,
  withWidgetConfiguration,
} from "../../../node_modules/@sgwt-widget/core";
import { ApiBackedComponent } from "../../common/components/ApiBackedComponent";
import PieChart from "../../common/components/PieChart";
import { MakeGenericApiCall } from "../../common/generic/generic-api";
import {
  CheckReponseDataForError,
  GenericFilterBuilder,
} from "../../common/generic/generic-helper";
import { SCAttributes } from "../../common/generic/generic-sc-attributes";
import {
  IGenericAggregateResponse,
  IGenericRequest,
} from "../../common/generic/generic-types";
import { ConvertFilter } from "../../common/salescredit/salescredit-filter-help";
import {
  BuildSalesCreditFilters,
  CreateDateFromFilter,
} from "../../common/salescredit/salescredit-search-criteria";
import { IProps } from "../../common/salescredit/salescredit-types";
import { maxSelectedClients } from "../../common/utils/clientlistHelper";
import { mapData } from "../utils/helper";

interface IClientConcentrationState {
  data: any[];
  drillDownData: any[];
}

export class SalesCreditClientConcentrationClass extends ApiBackedComponent<
  IProps & IWidgetConfigurationProps,
  IClientConcentrationState
> {
  public constructor() {
    super();
    this.setState({
      data: [],
      drillDownData: [],
    });
  }

  protected shouldFetchApiData(nextProps: IProps): boolean {
    if (!isEqual(this.props.filters, nextProps.filters)) {
      return true;
    }
    return false;
  }

  protected renderWithDataReady(): JSX.Element {
    return (
      <PieChart
        data={this.state.data}
        drillDownData={this.state.drillDownData}
      />
    );
  }

  protected async fetchApiData(props: IProps) {
    this.initCorrelationId();
    const indicator = "sc";
    const kpis = "sc_ytd";
    const attributes = SCAttributes.SC_CLIENT_LEID;
    const sortOrder = "-sc_ytd";
    const headers = props.headers;
    let numberOfTopClients: any;

    if (
      props.filters !== undefined &&
      props.filters.text &&
      props.filters.text.length > 0
    ) {
      numberOfTopClients = props.filters.text;
    }

    const filtersConverted = ConvertFilter(props.filters);
    const filters = BuildSalesCreditFilters(filtersConverted);
    const top = numberOfTopClients ? Number(numberOfTopClients) : 100;

    this.setDataStatus("loading");

    const finalFilter = GenericFilterBuilder(filters)
      ? GenericFilterBuilder(filters)
      : "";
    const asOfDate = CreateDateFromFilter(filtersConverted);
    const genericRequestForTopX: IGenericRequest = {
      aggregationAttributes: attributes,
      date: asOfDate,
      filter: finalFilter,
      kpis,
      sort: sortOrder,
      topN: top,
      topNSort: sortOrder,
    };
    const genericRequestForAll: IGenericRequest = {
      date: asOfDate,
      filter: finalFilter,
      kpis,
      sort: sortOrder,
    };

    const filterClientsSelected = find(filters, {
      attribute: "clientgen_id",
    });
    const clientsCount = filterClientsSelected
      ? filterClientsSelected.value.split("+").length
      : 0;
    if (filterClientsSelected && clientsCount >= maxSelectedClients) {
      this.setState({
        data: [],
      });
      this.setDataStatus("too-many-clients");
    } else {
      const responseDataForTopX = await MakeGenericApiCall(
        headers,
        indicator,
        genericRequestForTopX,
        this.props.widgetConfiguration,
        this.state.correlationId
      );

      const responseDataForAll = await MakeGenericApiCall(
        headers,
        indicator,
        genericRequestForAll,
        this.props.widgetConfiguration,
        this.state.correlationId
      );
      this.ProcessData(responseDataForTopX, responseDataForAll, top);
    }
  }

  private ProcessData(
    responseDataForTopX: IGenericAggregateResponse,
    responseDataForAll: IGenericAggregateResponse,
    top: number
  ) {
    const errorStatusForTopX = CheckReponseDataForError(responseDataForTopX);
    const errorStatusForAll = CheckReponseDataForError(responseDataForAll);
    const error = errorStatusForTopX || errorStatusForAll;
    const statutText =
      responseDataForTopX.statusText != undefined
        ? responseDataForTopX.statusText
        : responseDataForAll.statusText;
    if (error) {
      this.setDataStatus(error === undefined ? "no-data" : error);
      this.setStatusText(statutText);
      this.setState({
        data: [],
      });
      return;
    }
    const result = mapData(responseDataForTopX, responseDataForAll, top);
    if (result !== undefined && result.data !== undefined) {
      if (result.data.length !== 0) {
        this.setState({
          data: result.data,
        });
        this.setDataStatus("ready");
      }
    } else {
      this.setState({
        data: [],
      });
      this.setDataStatus("no-data");
    }
  }
}
export const SalesCreditClientConcentration = withWidgetConfiguration(
  SalesCreditClientConcentrationClass
);
